var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticStyle:{"width":"100%","height":"98%"},attrs:{"src":_vm.link,"frameborder":"0"}})
}
var staticRenderFns = []

export { render, staticRenderFns }